window._ = require('lodash');

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.moment = require('moment');
    window.Vue = require('vue').default;

    require('bootstrap');

    require('select2');
    require('select2/dist/js/i18n/it');
} catch (e) {}

import 'livewire-vue';

// import AirDatepicker
import AirDatepicker from 'air-datepicker';
import AirDatepickerLocaleIt from './includes/air-datepicker/locale/it/it.js';
window.AirDatepicker = AirDatepicker;
window.AirDatepickerLocaleIt = AirDatepickerLocaleIt;
// import AirDatepicker css
import 'air-datepicker/air-datepicker.css';

// import Dropzone
import { Dropzone } from 'dropzone';
window.Dropzone = Dropzone;
Dropzone.autoDiscover = false;

// import SortableJS (with all plugins)
import Sortable from 'sortablejs/modular/sortable.complete.esm.js';
window.Sortable = Sortable;

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
// import styles bundle
import 'swiper/css/bundle';

// Custom Myosotis chat
import MChat from './mchat.js';
window.MChat = MChat;

// Custom Myosotis Stripe payment
import MCheckout from './mcheckout.js';
window.MCheckout = MCheckout;

// ChartJs
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
window.Chart = Chart;

// ClipboardJS
import ClipboardJS from 'clipboard';
window.ClipboardJS = ClipboardJS;

// simple notify
import Notify from 'simple-notify';
window.Notify = Notify;
import 'simple-notify/dist/simple-notify.min.css';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true,
    namespace: 'Myosotis.Events'
});
